module.exports = __webpack_public_path__ + "static/media/i-follow-header.c63bbcfd.jpg";